import { DOCUMENT_SUBMISSION_METHODS } from '../../../onboarding/constants';

export const DESKTOP_MOBILE_CAPTURE_MESSAGE =
  "If you don't have the document on your computer, scan the QR code to continue on your mobile device. You'll be prompted to capture or upload it, and it will appear here.";

// Long enough for the caregiver to fetch their phone, scan the QR code, sign in, and capture the
// document before the countdown restarts — a 10s cycle churned the API and read as broken.
export const DESKTOP_MOBILE_CAPTURE_DOCUMENT_POLL_INTERVAL_SECONDS = 30;

export const DOCUMENT_UPLOAD_METHOD_OPTIONS_DESKTOP = [
  { value: DOCUMENT_SUBMISSION_METHODS.UPLOADED, label: 'Upload from your computer' },
  {
    value: DOCUMENT_SUBMISSION_METHODS.CAPTURED,
    label: 'Capture / Upload from your mobile device',
  },
] as const;

export const DOCUMENT_UPLOAD_METHOD_OPTIONS_MOBILE = [
  { value: DOCUMENT_SUBMISSION_METHODS.UPLOADED, label: 'Upload from this device' },
  { value: DOCUMENT_SUBMISSION_METHODS.CAPTURED, label: 'Capture using this device' },
] as const;
